import { inject, Injectable } from '@angular/core';
import { IHttpErrorHandlerService, NormalizedHttpErrorValueObject } from '@gishub/domain';
import { ToastService } from './toast-service';
import { AuthProvider } from '../../features/auth/shared/auth-provider';

@Injectable({ providedIn: 'root' })
export class HttpErrorHandlerService implements IHttpErrorHandlerService {
  private static readonly TOAST_COOLDOWN_MS = 8000;

  private readonly toast = inject(ToastService);
  private readonly auth = inject(AuthProvider);
  private lastToastAt = 0;
  // Si la red cae y se muestra el aviso, no volvemos a advertir hasta que
  // el cliente HTTP registre una petición exitosa (red recuperada).
  private connectionErrorShown = false;

  public notifyConnectionRecovered(): void {
    this.connectionErrorShown = false;
  }

  handle(error: NormalizedHttpErrorValueObject): void {
    const now = Date.now();
    const showToast = now - this.lastToastAt >= HttpErrorHandlerService.TOAST_COOLDOWN_MS;
    if (showToast) {
      this.lastToastAt = now;
    }

    if (error.status === 401) {
      if (this.auth.state().isAuthenticated) {
        this.auth.notifier.logout();
        if (showToast) {
          this.toast.warn('Sesión expirada', 'Inicie sesión nuevamente.');
        }
      }
      return;
    }

    if (error.status === undefined) {
      // Error de conexión: se muestra una sola vez y no se repite mientras la
      // red siga caída (se reinicia en cuanto el cliente registra una petición
      // exitosa, es decir, que la red se ha recuperado).
      if (showToast && !this.connectionErrorShown) {
        this.connectionErrorShown = true;
        this.toast.error('Sin conexión', error.message);
      }
      return;
    }

    if (error.status >= 500) {
      if (showToast) {
        this.toast.error('Error del servidor', error.message);
      }
      return;
    }

    if (showToast) {
      this.toast.warn('Solicitud no procesada', error.message);
    }
  }
}
